<template>
  <div class="p-6">
    <FilterTable
      v-on:change="filter"
      :paginated="true"
      :columns="columns"
      :items="transactions"
      :filterData="filtre"
      :isLoading="isLoading"
    >
      <template #status="{ item }">
        <div
          class="
            flex
            items-center
            justify-center
            bg-red-100
            rounded-xl
            py-1
            space-x-2
            px-2
          "
          v-bind:class="{
            ' bg-green-100': item.status == 'successeed',
            'bg-warning-100': item.status == 'pending'
          }"
        >
          <div
            class="rounded-full w-2 h-2 bg-danger"
            v-bind:class="{
              'bg-success': item.status == 'successeed',
              'bg-warning': item.status == 'pending'
            }"
          ></div>
          <span
            class="text-danger font-bold"
            v-bind:class="{
              'text-success': item.status == 'successeed',
              'text-warning': item.status == 'pending'
            }"
          >
            {{
              item.status == 'successeed'
                ? 'Succes'
                : item.status == 'pending'
                ? 'En attente'
                : 'Echec'
            }}</span
          >
        </div>
      </template>
    </FilterTable>
  </div>
</template>

<script>
import FilterTable from '../../../../components/TableWithFilter.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { TransactionService } from '@/api/services/transactions'
import { OrganizationService } from '@/api/services/organizations'

const TransactionStatus = {
  ALL: '',
  PENDING: 'pending',
  SUCCESSEED: 'successeed',
  FAILED: 'failed'
}

export default {
  components: {
    FilterTable
  },
  data() {
    return {
      organizations: [],
      rawTransactions: [],
      isLoading: false,
      columns: [
        { label: 'ID transaction', field: 'kkiapayTransactionId' },
        { label: 'Téléphone', field: 'source' },
        { label: 'Montant ', field: 'amount' },
        { label: 'Date de transaction ', field: 'createdAt' },
        { label: 'Entité ', field: 'entity' },
        { label: 'Type de transaction ', field: 'type' },
        { label: 'Initiateur ', field: 'initiator' },
        { label: 'Destinataire ', field: 'destinataire' },
        { label: 'Status ', field: 'status' }
      ],
      filtre: []
    }
  },

  computed: {
    ...mapGetters('product', ['getCurrentProduct']),
    ...mapGetters('auth', ['user']),

    isFnm() {
      return !!(
        this.user &&
        this.user.organization &&
        this.user.organization.isFnm
      )
    },

    transactions() {
      return this.rawTransactions.map(transaction => ({
        source: transaction.source,
        otm: transaction.otm,
        reference: transaction.reference,
        amount: transaction.amount,
        kkiapayTransactionId:
          transaction.otmTransactionId || transaction.kkiapayTransactionId,
        type: transaction.type,
        status: transaction.status,
        destinataire: transaction.destination,
        initiator: transaction.initiator,
        createdAt: moment(transaction.createdAt).format('DD/MM/YYYY, hh:mm'),
        entity: transaction.organization?.isFnm
          ? 'FNM'
          : transaction.organization?.name || ''
      }))
    }
  },

  methods: {
    async filter(data) {
      this.isLoading = true
      try {
        this.rawTransactions = await TransactionService.searchAll({
          search: data.search || '',
          otm: data.otm || '',
          status: data.status || '',
          from: data.dateDebut || '',
          to: data.dateFin || '',
          // Un SFD ne voit que ses propres transactions
          organizationId: this.isFnm
            ? data.organizationId || ''
            : this.user.organizationId
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    }
  },

  async mounted() {
    this.filtre = [
      {
        title: 'OTM',
        model: 'otm',
        items: [
          { label: 'Tous les OTM', value: '' },
          { label: 'MTN', value: 'mtn' },
          { label: 'Moov', value: 'moov' }
        ]
      },
      {
        title: 'Status',
        status: 'status',
        model: 'status',
        items: [
          { label: 'Tous les status', value: TransactionStatus.ALL },
          { label: 'Succès', value: TransactionStatus.SUCCESSEED },
          { label: 'Échec', value: TransactionStatus.FAILED },
          { label: 'En attente', value: TransactionStatus.PENDING }
        ]
      }
    ]

    // Liste des SFD + filtre par SFD : reserves au FNM
    // (un SFD n'appelle pas /organizations -> evite le 401 et la deconnexion)
    if (this.isFnm) {
      try {
        this.organizations = (
          await OrganizationService.findAll(
            this.getCurrentProduct.sfdConcern || []
          )
        ).map(organization => ({
          label: organization.name,
          value: organization.id
        }))

        this.filtre.unshift({
          title: 'SFD',
          model: 'organizationId',
          items: [{ label: 'Tous les SFDs', value: '' }, ...this.organizations]
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style></style>
